atomic-field-condition {
  max-width: 100%;
}
